import React from 'react'
import {Box, Card, CardActionArea, CardContent, Typography} from "@mui/material";
import useStyles from "../../assets/styles/HomeStyles";
import {useHistory} from "react-router-dom";
import Icon1 from "../../assets/images/DQProImages/Onboarded_icon1.png"
import Icon2 from "../../assets/images/DQProImages/Onboarded_icon2.png"
import Icon3 from "../../assets/images/DQProImages/Onboarded_icon3.png"
import Icon4 from "../../assets/images/DQProImages/Onboarded_icon4.png"

const DQProOnboarded= ()=>{
    const classes = useStyles();
    const history = useHistory();
    const cardData = [
        {
            image: Icon1,
            title: (
                <>
                    How to <br/> Start?
                </>
            ),
            description: 'Instructions on how to use your Powered by DQ Portal.',
            url: '/dq_pro/onboarded/how-to-start'
        },
        {
            image: Icon2,
            title: (
                <>
                    What Can <br/> You Do?
                </>
            ),
            description: 'Sell products or build your own. Learn how.',
            url: '/dq_pro/onboarded/what-you-can-do'
        },
        // {
        //     image: Icon3,
        //     title: (
        //         <>
        //             How Much Can <br/> You Earn?
        //         </>
        //     ),
        //     description: 'Understand your product cost and how much you can earn.',
        //     url: '/dq_pro/onboarded/what-can-you-earn'
        // },
        // {
        //     image: Icon4,
        //     title: (
        //         <>
        //             <b>DQ</b>pro <br/> Rewards
        //         </>
        //     ),
        //     description: 'Discover rewards for unlocking sales goals.',
        //     url: '/dq_pro/onboarded/rewards'
        // },
    ];

    const handleCardClick = (url) => {
        if (url) {
            history.push(url);
        }
    };

    return(
        <>
            <Box className={classes.pageContainer} style={{marginTop:'auto'}}>
                <Typography variant="h3" sx={{ textAlign: "center", marginBottom:{sm:2, xs:1}, marginTop:{xs:'0px', sm:'0px'} }} className={classes.title}>
                    Get Onboarded
                </Typography>

                <Box className={classes.cardsContainer} sx={{flexDirection: { xs: "column", sm: "row" }, alignItems:'center', justifyContent:'center'}}>
                    {cardData.map((card, index) => (
                        <Card key={index} className={classes.card} onClick={card.action}>
                            <CardActionArea
                                onClick={() => handleCardClick(card.url)}
                            >
                            <CardContent className={classes.cardContent}>
                                    <img src={card.image} className={classes.cardImage} alt="Card Image" />
                                <Typography variant="h5" mt="1" style={{fontWeight:'bold', marginTop:'20px', color:'#000000'}}>
                                    {card.title}
                                </Typography>

                                <Typography paragraph style={{fontSize:'20px',lineHeight:'1.1',padding: '10px 30px',marginTop:'20px',marginLeft:'10px', height: '100px', textAlign: 'center', color:'#000000'}}>
                                    {card.description}
                                </Typography>
                            </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
                </Box>
            </Box>
        </>
    )
}

export default DQProOnboarded;